/**
 * 投标报名相关接口
 */
import request from '@/utils/request'

//查询可投标报名列表
export const getRegistrationList = (data) => {
    return request.get('/api/bid/registration/list', data)
}
//获取报名信息
export const getRegisterInfo = (data) => {
    return request.get('/api/bid/registration/getRegisterInfo', data)
}
//提交报名信息
export const addRegister = (data) => {
    return request.post('/api/bid/registration/addRegister', data)
}

//查询已投标报名列表
export const getRegisterList = (data) => {
    return request.get('/api/bid/registration/getRegisterList', data)
}

/**
 * 购标订单相关接口
 */
// 购标订单列表
export const getOrderList = (data) => {
    return request.get('/api/bid/order/list', data)
}
// 订单号进入标书款详情
export const getOrderDetail = (data) => {
        return request.get('/api/bid/order/detail', data)
}
// 通过标段编码进入标书款详情
export const getOrCreateBySectionCode = (data) => {
    return request.get('/api/bid/order/getOrCreateBySectionCode', data)
}
//提交标书款订单
export const submitOrder = (data) => {
    return request.post('/api/bid/order/submitOrder', data)
}
// 分页查询我购标的项目列表
export const getPurchasedProjectList = (data) => {
    return request.get('/api/bid/order/purchasedProjectList', data)
}

// 通过标段编码进入平台使用费订单详情
export const createPlatformServiceOrder = (data) => {
    return request.get('/api/bid/order/createPlatformServiceOrder', data)
}
//订单号进入平台使用费订单详情
export const platformServiceOrderDetail = (data) => {
    return request.get('/api/bid/order/platformServiceOrderDetail', data)
}

// 获取投标文件上传详情
export const getUploadDocumentDetail = (data) => {
    return request.get('/api/bid/order/uploadDocumentDetail', data)
}

// 上传投标文件
export const uploadBidDocument = (data) => {
    return request.post('/api/bid/order/uploadBidDocument', data)
}
//撤销投标文件
export const cancelBidDocument = (data) => {
    return request.get('/api/bid/order/cancelBidDocument', data)
}
// 撤销投标文件 (revoke)
export const revokeBidDocument = (data) => {
    return request.get('/api/bid/order/revokeBidDocument', data)
}
//上传投标文件列表
export const getUploadDocumentList = (data) => {
    return request.get('/api/bid/order/paidPlatformServiceSectionList', data)
}

// 上传投标文件项目相关信息
export const uploadBidDocumentInfo = (data) => {
    return request.post('/api/bid/order/upload-info', data)
}

/**
 * 发票相关
 */
//获取订单相关发票详情
export const invoiceInfo = (data) => {
    return request.get('/api/bid/order/invoiceInfo', data)
}
//提交订单发票信息
export const submitInvoiceInfo = (data) => {
    return request.post('/api/bid/order/submitInvoice', data)
}
// 更新投标文件项目相关参数
export const updateBidDocument = (data) => {
    return request.post('/api/bid/order/upload/pm/update', data)
}
//下载投标文件接收回执PDF
export const downloadReceiptPdf = (data) => {
    return request.get('/api/bid/order/receiptPdf', data, {
        responseType: 'blob'
    })
}